import script from "./TableListShell.vue?vue&type=script&setup=true&lang=js"
export * from "./TableListShell.vue?vue&type=script&setup=true&lang=js"

import "./TableListShell.vue?vue&type=style&index=0&id=0a33f7ac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a33f7ac"]])

export default __exports__